// extracted by css-extract-rspack-plugin
export default {"databaseDataSelectors":"UrllU"};